import logFormError from "./log_form_error.js";

export default function (action, error) {
    try {
        let errorMessage = 'Sorry, there was a connection error. Please try again later.';

        if (error?.response?.data?.data?.errors) {

            errorMessage = 'Sorry, there was a error.';
            for (let errerText of error.response.data.data.errors) {
                let errorTextCapital = errerText.charAt(0).toUpperCase() + errerText.slice(1);
                if (errorTextCapital.charAt(errorTextCapital.length - 1) !== '.') {
                    errorTextCapital += '.';
                }
                errorMessage += `<br />\n - ${errorTextCapital}`;
            }

        } else if (error?.response?.data?.data?.message) {

            errorMessage = error?.response?.data?.data?.message;
        } else if (error?.message) {

            errorMessage = error.message;
        }

        let userData = JSON.parse(JSON.stringify(this.userData));
        userData.password = 'removed';
        userData.login = userData.login ? userData.login : {};
        userData.register = userData.register ? userData.register : {};
        userData.login.password = 'removed';
        userData.register.password = 'removed';
        userData.register.confirmPassword = 'removed';

        logFormError(action, error, errorMessage, userData);

        console.error(action + ' action error: ', error);
        this.errorMessage = errorMessage;
    } catch (err2) {
        console.error('Original error:', error);
        console.error('Unhandled error:', err2);
    }
};
